import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { cn } from 'lib/utils'
import { CheckIcon } from 'lucide-react'
import * as React from 'react'

function Checkbox({
  className,
  variant = 'default',
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  /** `default` — legacy purple primary. `dark` — T3 dual-theme (acid checked). */
  variant?: 'default' | 'dark'
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer size-4 shrink-0 transition-shadow outline-none disabled:cursor-not-allowed disabled:opacity-50',
        variant === 'default' &&
          'rounded-[4px] border border-input shadow-xs focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-primary',
        // The base surface/border use arbitrary-value utilities on purpose:
        // `.bg-bg-3` / `.border-line-bright` are UNLAYERED shim classes in
        // design-system.css, and unlayered CSS beats Tailwind's layered
        // `data-[state=checked]:*` variants regardless of specificity, so the
        // checked acid fill never showed. Layered vs layered, the variant wins.
        variant === 'dark' &&
          'text-ink-on-acid rounded-[4px] border border-[var(--line-bright)] bg-[var(--bg-3)] focus-visible:ring-2 focus-visible:ring-acid focus-visible:ring-offset-2 focus-visible:ring-offset-bg data-[state=checked]:border-acid data-[state=checked]:bg-acid',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
